module.exports = __webpack_public_path__ + "static/img/185_TO8_2048_og.76738e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/185_TO8_2048_og.jpg
// module id = vTGl
// module chunks = 0